export default "__VITE_ASSET__BZwQ3biI__"